import Paper from 'material-ui/Paper/Paper';

export default Paper;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Paper/index.ts